import ReactValidator from "legacy/ReactValidator.es6"
import PropTypes from "prop-types"
import React from "react"

class AddBoatPageOne extends React.Component {
  constructor(props) {
    super(props)
    this.validator = new ReactValidator(["boatName", "boatMake", "boatModel"])
    this.setBoatName = this.setBoatName.bind(this)
    this.setBoatMake = this.setBoatMake.bind(this)
    this.setBoatModel = this.setBoatModel.bind(this)
    this.nextButton = this.nextButton.bind(this)
    this.changeBoatType = this.changeBoatType.bind(this)
  }

  componentDidMount() {
    this.props.setHeader("Add Boat")
  }

  setBoatName(event) {
    this.props.setGlobalState({ boatName: event.target.value })
  }

  setBoatMake(event) {
    this.props.setGlobalState({ boatMake: event.target.value })
  }

  setBoatModel(event) {
    this.props.setGlobalState({ boatModel: event.target.value })
  }

  nextButton() {
    this.validator.displayErrors()
    this.setState({ validInputs: this.validator.allValid() })
    if (this.validator.allValid() === true) {
      this.props.routeTo("next")
    }
  }

  changeBoatType(event) {
    this.props.setGlobalState({ boatType: event.target.value })
  }

  render() {
    return (
      <div id="addBoatPageOne" className="add-boat-page-one">
        <div className="form-group">
          <label htmlFor="boatType">Boat type</label>
          <select
            id="boatType"
            className="form-control"
            value={this.props.boatType}
            onChange={this.changeBoatType}
            autoFocus
          >
            <option id="powerBoat" value="power">
              Power Boat
            </option>
            <option id="sailBoat" value="sail">
              Sailboat
            </option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="boatName">Boat name</label>
          <input
            id="boatName"
            className="form-control"
            value={this.props.boatName}
            onChange={this.setBoatName}
          />
          {this.validator.message("boatName", this.props.boatName, "required")}
        </div>
        <div className="form-group">
          <label htmlFor="boatMake">Boat make</label>
          <input
            id="boatMake"
            className="form-control"
            value={this.props.boatMake}
            onChange={this.setBoatMake}
          />
          {this.validator.message("boatMake", this.props.boatMake, "required")}
        </div>
        <div className="form-group">
          <label htmlFor="boatModel">Boat model</label>
          <input
            id="boatModel"
            className="form-control"
            value={this.props.boatModel}
            onChange={this.setBoatModel}
          />
          {this.validator.message(
            "boatModel",
            this.props.boatModel,
            "required"
          )}
        </div>
        <button
          id="addBoatPageOneNextButton"
          type="button"
          className="btn btn-primary"
          onClick={this.nextButton}
        >
          Continue
        </button>
      </div>
    )
  }
}

AddBoatPageOne.propTypes = {
  setGlobalState: PropTypes.func.isRequired,
  setHeader: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  boatName: PropTypes.string,
  boatMake: PropTypes.string,
  boatModel: PropTypes.string,
  boatType: PropTypes.string,
}

export default AddBoatPageOne
